import { useRouteLoaderData } from "react-router";
import {
	WORKSPACE_LOADER_ID,
	type WorkspaceLoaderData,
} from "@/routes/workspaceLoader";
import { useAuth } from "@/hooks/useAuth";

export const useAuthenticatedUser = () => {
	const loaderData = useRouteLoaderData(WORKSPACE_LOADER_ID) as
		| WorkspaceLoaderData
		| undefined;
	const { user } = useAuth();
	const resolvedUser = loaderData?.user ?? user ?? undefined;

	if (!resolvedUser) {
		throw new Error(
			"useAuthenticatedUser must be used within an authenticated route",
		);
	}

	return resolvedUser;
};

export type AuthenticatedUser = ReturnType<typeof useAuthenticatedUser>;
